import { sendPageview } from 'analytics/events/gtag/sendPageview/sendPageview'
import { startGTM } from 'analytics/utils/startGTM/startGTM'
import type { Dispatch, SetStateAction } from 'react'
import type { Session } from 'session/src/types/session'
import type { MasterData } from 'types/masterData'

interface ResetDataLayerParams {
	setIsGTMLoaded: Dispatch<SetStateAction<boolean>>
	masterData: MasterData
	session: Session
}
export const resetDataLayer = ({
	setIsGTMLoaded,
	masterData,
	session,
}: ResetDataLayerParams) => {
	if (window.dataLayer?.length) {
		window.dataLayer.length = 0
		startGTM()
		sendPageview(setIsGTMLoaded, masterData, session)
	}
}
